import { InjectionToken } from '@angular/core';

export const EXPEPHARMA_APP_CONFIG = new InjectionToken<any>(
    'EXPEPHARMA_APP_CONFIG'
);
